module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_clipped.7e1852e1.tom";